export const RadiologyReferralForm = {
  flow: 'y',
  gap: 'A',
  padding: 'B',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',

  FormTitle: { text: '{{ newRadiologyReferral | polyglot }}', fontSize: 'B', fontWeight: '700', color: 'inkText' },

  PatientField: {
    flow: 'y', gap: 'Y',
    Label: { text: '{{ patientName | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
    Input: {
      tag: 'input', type: 'text', placeholder: 'Giorgi Beridze',
      padding: 'Z', round: 'Z', border: '1px solid inkBorder', background: 'inkSurface', color: 'inkText', fontSize: 'Z', outline: 'none', width: '100%',
      value: (el, s) => (s.root.newReferral && s.root.newReferral.patientName) || '',
      onInput: (e, el, s) => s.root.update({ newReferral: { ...(s.root.newReferral || {}), patientName: e.target.value } })
    }
  },

  ImagingTypeField: {
    flow: 'y', gap: 'Y',
    Label: { text: '{{ imagingType | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
    ImagingTypeSelector: {}
  },

  TargetAreaField: {
    flow: 'y', gap: 'Y',
    Label: { text: '{{ targetArea | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
    Input: {
      tag: 'input', type: 'text', placeholder: '#14, #15 or Full Mouth',
      padding: 'Z', round: 'Z', border: '1px solid inkBorder', background: 'inkSurface', color: 'inkText', fontSize: 'Z', outline: 'none', width: '100%',
      value: (el, s) => (s.root.newReferral && s.root.newReferral.targetArea) || '',
      onInput: (e, el, s) => s.root.update({ newReferral: { ...(s.root.newReferral || {}), targetArea: e.target.value } })
    }
  },

  ClinicalQuestionField: {
    flow: 'y', gap: 'Y',
    Label: { text: '{{ clinicalQuestion | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
    TextArea: {
      tag: 'textarea', placeholder: 'What do you need to evaluate?',
      padding: 'Z', round: 'Z', border: '1px solid inkBorder', background: 'inkSurface', color: 'inkText', fontSize: 'Z', outline: 'none', width: '100%', minHeight: '80px', resize: 'vertical', fontFamily: 'inherit',
      value: (el, s) => (s.root.newReferral && s.root.newReferral.clinicalQuestion) || '',
      onInput: (e, el, s) => s.root.update({ newReferral: { ...(s.root.newReferral || {}), clinicalQuestion: e.target.value } })
    }
  },

  UrgencyField: {
    flow: 'y', gap: 'Y',
    Label: { text: '{{ urgency | polyglot }}', fontSize: 'Y', fontWeight: '600', color: 'inkMuted' },
    Options: {
      flow: 'x', gap: 'Z',
      NormalBtn: {
        tag: 'button', text: '{{ normal | polyglot }}', padding: 'Y A', round: 'Z', fontSize: 'Z', fontWeight: '600', cursor: 'pointer', border: 'none',
        background: (el, s) => (s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'inkSurface' : 'teal',
        color: (el, s) => (s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'inkMuted' : 'white',
        onClick: (e, el, s) => s.root.update({ newReferral: { ...(s.root.newReferral || {}), urgency: 'normal' } })
      },
      UrgentBtn: {
        tag: 'button', text: '{{ urgent | polyglot }}', padding: 'Y A', round: 'Z', fontSize: 'Z', fontWeight: '600', cursor: 'pointer', border: 'none',
        background: (el, s) => (s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'red' : 'inkSurface',
        color: (el, s) => (s.root.newReferral && s.root.newReferral.urgency) === 'urgent' ? 'white' : 'inkMuted',
        onClick: (e, el, s) => s.root.update({ newReferral: { ...(s.root.newReferral || {}), urgency: 'urgent' } })
      }
    }
  },

  SubmitBtn: {
    extends: 'Button',
    text: '{{ submitReferral | polyglot }}',
    fontSize: 'Z',
    padding: 'Z A',
    round: 'Z',
    background: 'teal',
    color: 'white',
    fontWeight: '700',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    marginTop: 'Z',
    onClick: (e, el, s) => {
      const ref = s.root.newReferral || {}
      const queue = s.root.radiologyQueue || []
      queue.unshift({
        id: 'RAD-' + Date.now(),
        patientName: ref.patientName || 'Unknown',
        referringDoctor: 'Dr. Lomidze',
        imagingType: s.root.selectedImagingType || 'Periapical',
        targetArea: ref.targetArea || '',
        clinicalQuestion: ref.clinicalQuestion || '',
        urgency: ref.urgency || 'normal',
        status: 'pending',
        createdAt: new Date().toLocaleString()
      })
      s.root.update({ radiologyQueue: queue, newReferral: {}, selectedImagingType: null, radiologyTab: 'queue' })
    }
  }
}
